module.exports = __webpack_public_path__ + "assets/img/map-ru.6409b864.png";